<template>
  <v-container fluid>
    <v-card :flat="true">
      <v-card v-show="!displayConfirmDialog && !displayCompletedDialog && isWordListReady" :flat="true">
        <Form ref="operatorFormRef" v-slot="{ meta }">
          <v-card :flat="true">
            <v-card-title
              v-if="!listEditFlag"
              class="mb-3 text-h5 font-weight-bold"
              >{{ wordList.lbl_operator_regist }}</v-card-title
            >
            <v-card-title v-else class="mb-3 text-h5 font-weight-bold">
              オペレータ編集
            </v-card-title>
            <v-card-text>
              <v-card :flat="true" class="pl-5 pt-3">
                <v-row
                  v-if="
                    !updateMode ||
                    !listEditFlag
                  "
                    class="mb-5"
                >
                  <!-- 所属グループ -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_operator_group }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>
                    <Field
                      v-slot="{ field, errors }"
                      name="operatorGroup"
                      :label="wordList.lbl_operator_group"
                      rules="required"
                    >
                      <v-radio-group
                        :model-value="field.value ?? groupSelectValues"
                        inline
                        mandatory
                        class="mt-0"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            groupSelectValues = val;
                            onClickGroup(val.index);
                          }
                        "
                        @blur="field.onBlur"
                      >
                        <v-radio
                          v-for="item in groupRadioItems"
                          :key="item.index"
                          :label="item.item"
                          :value="item"
                          color="indigo"
                          :error-messages="errors"
                          density="compact"
                        ></v-radio>
                      </v-radio-group>
                    </Field>
                  </v-col>
                </v-row>
                <v-row v-if="updateMode" class="mb-5">
                  <!-- 所属グループ編集モード -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_operator_group }}
                    </v-row>
                  </v-col>
                  <v-col>
                    {{ selectedOperatorGroupName }}
                  </v-col>
                </v-row>
                <v-row class="mb-5">
                  <!-- 権限 -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_auth_type }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>
                    <Field
                      v-slot="{ field, errors }"
                      name="authType"
                      :label="wordList.lbl_auth_type"
                      rules="required"
                    >
                      <v-radio-group
                        :model-value="field.value ?? authtypeSelectValues"
                        inline
                        mandatory
                        class="mt-0"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            authtypeSelectValues = val;
                            onClickAuthType(val.index);
                          }
                        "
                        @blur="field.onBlur"
                      >
                        <v-radio
                          v-for="item in authtypeRadioItems"
                          :key="item.index"
                          :label="item.item"
                          :value="item"
                          color="indigo"
                          :error-messages="errors"
                          density="compact"
                        ></v-radio>
                      </v-radio-group>
                    </Field>
                  </v-col>
                </v-row>
                <v-row v-if="!updateMode && chainViewFlag">
                  <!-- チェーン名 -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_chain_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="chainName"
                      :label="wordList.lbl_chain_name"
                      rules="required"
                    >
                      <v-autocomplete
                        :model-value="field.value ?? chainSelectValues"
                        density="compact"
                        :items="chainListItems"
                        item-title="name"
                        item-value="chain_code"
                        :label="wordList.lbl_chain_name"
                        :placeholder="wordList.plc_selectbox"
                        :error-messages="errors"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            chainSelectValues = val;
                            onChangeChain();
                          }
                        "
                        @blur="field.onBlur"
                      ></v-autocomplete>
                    </Field>
                  </v-col>
                </v-row>
                <v-row v-if="updateMode" align="center" class="mb-5">
                  <!-- チェーン名編集モード -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_chain_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      name="chainNameEdit"
                      rules="required"
                      :label="wordList.lbl_chain_name"
                      v-slot="{ field }"
                    >
                      <!-- テキスト表示のみ（グレーアウト解消 #193） -->
                      <span>{{ field.value ?? selectedOperatorChainName }}</span>
                    </Field>
                  </v-col>
                </v-row>
                <v-row v-if="shopViewFlag">
                  <!-- 店舗名 -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_shop_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors, meta: fieldMeta }"
                      name="shopName"
                      :label="wordList.lbl_shop_name"
                      rules="required"
                    >
                      <v-autocomplete
                        :model-value="field.value ?? shopSelectValues"
                        density="compact"
                        :items="shopListItems"
                        item-title="name"
                        item-value="shop_code"
                        :label="wordList.lbl_shop_name"
                        :placeholder="wordList.plc_selectbox"
                        :error-messages="fieldMeta.touched ? errors : []"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            shopSelectValues = val;
                          }
                        "
                        @blur="field.onBlur"
                      ></v-autocomplete>
                    </Field>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- オペレータID -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_operator_id }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col
                    v-if="!updateMode || !listEditFlag"
                    cols="3"
                  >
                    <Field
                      v-slot="{ field, errors, meta: fieldMeta }"
                      name="operatorId"
                      :label="wordList.lbl_operator_id"
                      rules="required|max:10|alpha_dash"
                    >
                      <v-text-field
                        :model-value="field.value ?? cognitUserCreateInput.user_id"
                        :placeholder="wordList.plc_operator_id"
                        density="compact"
                        variant="outlined"
                        :error-messages="fieldMeta.touched ? errors : []"
                        :disabled="
                          (!chainSelectValues ||
                            chainSelectValues.chain_code.length <= 0) &&
                          isOperatorGroupOtherFlag &&
                          !isSelectOperatorGroupOther
                        "
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            cognitUserCreateInput.user_id = val;
                          }
                        "
                        @blur="
                          () => {
                            field.onBlur();
                            onBlurOperatorId();
                          }
                        "
                      ></v-text-field>
                    </Field>
                  </v-col>
                  <v-col
                    v-if="updateMode && listEditFlag"
                    cols="3"
                    class="d-flex align-center mb-5"
                  >
                    <Field
                      v-slot="{ field }"
                      name="operatorIdEdit"
                      :label="wordList.lbl_operator_id"
                      rules="required|max:10|alpha_dash"
                    >
                      <!-- テキスト表示のみ（グレーアウト解消 #193） -->
                      <span>{{ field.value ?? cognitUserCreateInput.user_id }}</span>
                    </Field>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- 登録名称 -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_operator_regist_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="operatorRegistName"
                      :label="wordList.lbl_operator_regist_name"
                      rules="required|max:1280"
                    >
                      <v-text-field
                        :model-value="field.value ?? cognitUserCreateInput.name"
                        :placeholder="wordList.plc_operator_regist_name"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            cognitUserCreateInput.name = val;
                          }
                        "
                        @blur="field.onBlur"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
                <v-row class="mb-5">
                  <!-- 個人情報閲覧 -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_personal_info_browsing }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="personalInfoBrowsing"
                      :label="wordList.lbl_personal_info_browsing"
                      rules="required"
                    >
                      <v-radio-group
                        :model-value="field.value ?? personalSelectValues"
                        inline
                        mandatory
                        :error-messages="errors"
                        class="mt-0"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            personalSelectValues = val;
                          }
                        "
                        @blur="field.onBlur"
                      >
                        <v-radio
                          v-for="item in personalRadioItems"
                          :key="item.index"
                          :label="item.item"
                          :value="item"
                          color="indigo"
                          density="compact"
                          :disabled="personalDisabledFlag"
                        ></v-radio>
                      </v-radio-group>
                    </Field>
                  </v-col>
                </v-row>
                <v-row class="mb-5">
                  <!-- 個人情報ダウンロード -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ wordList.lbl_personal_info_download }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="personalInfoDownload"
                      :label="wordList.lbl_personal_info_download"
                      rules="required"
                    >
                      <v-radio-group
                        :model-value="field.value ?? personalDlSelectValues"
                        inline
                        mandatory
                        :error-messages="errors"
                        class="mt-0"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            personalDlSelectValues = val;
                          }
                        "
                        @blur="field.onBlur"
                      >
                        <v-radio
                          v-for="item in personalRadioItems"
                          :key="item.index"
                          :label="item.item"
                          :value="item"
                          color="indigo"
                          density="compact"
                          :disabled="personalDisabledFlag"
                        ></v-radio>
                      </v-radio-group>
                    </Field>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    email_required == 1 &&
                    (!updateMode || isIpRestrictedChain)
                  "
                >
                  <!-- 認証用E-mail / E-mail（本部タブ+IP制限ありチェーンの場合） -->
                  <!-- 編集モードでは認証用E-mail（IP制限なし）は非表示、E-mail（IP制限あり）は表示 -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end">
                      {{ emailLabel }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="authEmail"
                      :label="emailLabel"
                      rules="required|email|max:255"
                    >
                      <v-text-field
                        :model-value="field.value ?? cognitUserCreateInput.email"
                        :placeholder="wordList.plc_email"
                        density="compact"
                        variant="outlined"
                        :hint="wordList.lbl_no_hyphen"
                        persistent-hint
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            cognitUserCreateInput.email = val;
                          }
                        "
                        @blur="
                          () => {
                            field.onBlur();
                            onBlurEmail();
                          }
                        "
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
                <!--
                <v-row v-if="tel_required==1">
-->
                <!-- 認証用電話番号 -->
                <!--
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end"
                      >{{ wordList.lbl_auth_tel }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <Field
                      v-slot="{ errors }"
                      :name="wordList.lbl_auth_tel"
                      rules="required|max:11"
                    >
                      <v-text-field
                        :placeholder="wordList.plc_tel"
                        density="compact"
                        variant="outlined"
                        v-model="cognitUserCreateInput.phone_number"
                        :error-messages="errors"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
-->
                <v-row
                  v-if="!updateMode || !listEditFlag"
                >
                  <!-- パスワード 登録用-->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end"
                      >{{ wordList.lbl_auth_password }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="authPassword"
                      :label="wordList.lbl_auth_password"
                      rules="required|min:8|max:128"
                    >
                      <v-text-field
                        :model-value="field.value ?? cognitUserCreateInput.temporary_password"
                        :placeholder="wordList.plc_operator_password"
                        density="compact"
                        variant="outlined"
                        persistent-hint
                        :hint="wordList.lbl_operator_password_hint"
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            cognitUserCreateInput.temporary_password = val;
                          }
                        "
                        @blur="field.onBlur"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
                <v-row v-if="updateMode">
                  <!-- パスワード 編集用-->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-15" justify="end"
                      >{{ wordList.lbl_auth_password }}
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="authPasswordEdit"
                      :label="wordList.lbl_auth_password"
                      rules="min:8|max:128"
                    >
                      <v-text-field
                        :model-value="field.value ?? cognitUserCreateInput.temporary_password"
                        :placeholder="wordList.plc_operator_password"
                        density="compact"
                        variant="outlined"
                        persistent-hint
                        :hint="wordList.lbl_operator_password_hint"
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            cognitUserCreateInput.temporary_password = val;
                          }
                        "
                        @blur="field.onBlur"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
                <v-row
                  v-if="!updateMode || !listEditFlag"
                >
                  <!-- パスワード確認 登録用 -->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-3" justify="end"
                      >{{ wordList.lbl_auth_password_comfirm }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="authPasswordConfirm"
                      :label="wordList.lbl_auth_password_comfirm"
                      rules="required|confirmed:@authPassword|min:8|max:128"
                    >
                      <v-text-field
                        :model-value="field.value ?? comfirm_temporary_password"
                        :placeholder="wordList.plc_operator_password"
                        density="compact"
                        variant="outlined"
                        persistent-hint
                        :hint="wordList.lbl_operator_password_hint"
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            comfirm_temporary_password = val;
                          }
                        "
                        @blur="field.onBlur"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
                <v-row v-if="updateMode">
                  <!-- パスワード確認  編集用-->
                  <v-col cols="3" class="font-weight-black">
                    <v-row align="center" dense class="form-label-row mr-15" justify="end"
                      >{{ wordList.lbl_auth_password_comfirm }}
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="authPasswordConfirmEdit"
                      :label="wordList.lbl_auth_password_comfirm"
                      rules="confirmed:@authPasswordEdit|min:8|max:128"
                    >
                      <v-text-field
                        :model-value="field.value ?? comfirm_temporary_password"
                        :placeholder="wordList.plc_operator_password"
                        density="compact"
                        variant="outlined"
                        persistent-hint
                        :hint="wordList.lbl_operator_password_hint"
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            comfirm_temporary_password = val;
                          }
                        "
                        @blur="field.onBlur"
                      ></v-text-field>
                    </Field>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions class="justify-center py-10">
              <!-- 店舗一覧へ戻る -->
              <v-btn
                v-if="updateMode && listEditFlag"
                variant="flat"
                color="return"
                class="px-16"
                @click="onClickBack"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}</v-btn
              >
              <v-btn
                v-if="!updateMode"
                variant="flat"
                color="primary"
                class="px-16"
                :disabled="!meta.valid"
                @click="onClickOpenConfirmDialog"
              >
                <v-icon>mdi-playlist-edit</v-icon>
                {{ wordList.btn_regist_confirm }}
              </v-btn>
              <v-btn
                v-if="updateMode"
                variant="flat"
                color="primary"
                class="px-16"
                :disabled="!meta.valid"
                @click="onClickOpenConfirmDialog"
              >
                <v-icon>mdi-playlist-edit</v-icon>

                <span v-if="!listEditFlag">{{
                  wordList.btn_regist_confirm
                }}</span>
                <span v-else>変更手続きへ(確認)</span>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-overlay
            :model-value="overlay"
            class="d-flex align-center justify-center"
          >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </Form>
      </v-card>
      <!-- オペレータ登録確認ダイアログ { -->
      <v-card v-if="displayConfirmDialog" :flat="true">
        <v-card :flat="true">
          <v-card-title
            v-if="!listEditFlag"
            class="mt-3 pb-5 text-h5 font-weight-bold"
          >
            {{ wordList.lbl_operator_regist_confirm }}
          </v-card-title>
          <v-card-title v-else class="mt-3 pb-5 text-h5 font-weight-bold">
            オペレータ編集確認
          </v-card-title>
          <v-card-text class="pt-5 confirm-display-text">
            <v-row
              v-if="!updateMode || !listEditFlag"
                class="mb-3"
            >
              <!-- 所属グループ -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_operator_group }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{ groupSelectValues.item }}</v-col>
            </v-row>
            <v-row v-if="updateMode" class="mb-3">
              <!-- 所属グループ -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_operator_group }}
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{ selectedOperatorGroupName }}</v-col>
            </v-row>
            <v-row class="mb-3">
              <!-- 権限 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_auth_type }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{ authtypeSelectValues.item }}</v-col>
            </v-row>
            <v-row v-if="!updateMode && chainViewFlag" class="mb-3">
              <!-- チェーン名 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_chain_name }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col cols="6" class="text-body-1">{{
                chainSelectValues.name
              }}</v-col>
            </v-row>
            <v-row v-if="updateMode" class="mb-3">
              <!-- チェーン名 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_chain_name }}
                </v-row>
              </v-col>
              <v-col cols="6" class="text-body-1">
                {{ selectedOperatorChainName }}
              </v-col>
            </v-row>
            <v-row
              v-if="shopSelectValues && shopSelectValues.name !== ''"
                class="mb-3"
            >
              <!-- 店舗名 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_shop_name }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{ shopSelectValues.name }}</v-col>
            </v-row>
            <v-row class="mb-3">
              <!-- オペレータID -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_operator_id }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{
                cognitUserCreateInput.user_id
              }}</v-col>
            </v-row>
            <v-row class="mb-3">
              <!-- オペレータ登録名称 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_operator_regist_name }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{
                cognitUserCreateInput.name
              }}</v-col>
            </v-row>
            <v-row class="mb-3">
              <!-- 個人情報閲覧 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_personal_info_browsing }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{ personalSelectValues.item }}</v-col>
            </v-row>
            <v-row class="mb-3">
              <!-- 個人情報ダウンロード -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_personal_info_download }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{
                personalDlSelectValues.item
              }}</v-col>
            </v-row>
            <v-row
                class="mb-3"
              v-if="email_required == 1 && (!updateMode || isIpRestrictedChain)"
            >
              <!-- 認証用E-mail / E-mail（本部タブ+IP制限ありチェーンの場合） -->
              <!-- 編集モードでは認証用E-mail（IP制限なし）は非表示、E-mail（IP制限あり）は表示 -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ emailLabel }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{
                cognitUserCreateInput.email
              }}</v-col>
            </v-row>
            <!--<v-row class="mb-3">-->
            <!-- 認証用電話番号 -->
            <!--<v-col cols="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_auth_tel }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{
                cognitUserCreateInput.phone_number
              }}</v-col>
            </v-row>-->
            <v-row class="mb-3">
              <!-- パスワード -->
              <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                <v-row align="center" dense
                  v-if="!updateMode || !listEditFlag"
                    class="py-2 pl-2"
                  justify="end"
                  >{{ wordList.lbl_auth_password }}
                  <ImportantChip></ImportantChip>
                </v-row>
                <v-row align="center" dense
                  v-if="updateMode"
                    class="form-label-row pl-2 mr-11"
                  justify="end"
                  >{{ wordList.lbl_auth_password }}
                </v-row>
              </v-col>
              <v-col class="text-body-1">{{
                cognitUserCreateInput.temporary_password
              }}</v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              variant="flat"
              color="return"
              class="px-16"
              @click="onClickConfirmCancel"
            >
              <v-icon>mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}</v-btn
            >
            <v-btn
              variant="flat"
              color="primary"
              class="px-16"
              @click="onClickConfirmEntry"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              <span v-if="!listEditFlag">{{
                wordList.btn_regist_complete
              }}</span>
              <span v-else>変更手続きへ(完了)</span>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
      <!-- } オペレータ登録確認ダイアログ -->
      <!-- オペレータ登録完了ダイアログ { -->
      <v-card v-if="displayCompletedDialog" :flat="true">
        <v-card
          v-if="
            createCognitoUserMutation !== null &&
            createCognitoUserMutation !== undefined
          "
          :flat="true"
        >
          <v-card-title>{{
            wordList.lbl_operator_regist_complete
          }}</v-card-title>
          <v-card-text>
            <v-row class="pt-5">
              <v-col class="font-weight-black">
                {{ wordList.lbl_operator_regist_complete_msg }}
              </v-col>
            </v-row>
            <v-row class="ml-5">
              <!-- オペレータID -->
              <v-col cols="6" class="font-weight-black">
                {{ wordList.lbl_operator_id }} :
                {{ cognitUserCreateInput.user_id }}
              </v-col>
            </v-row>
            <v-row class="ml-5">
              <!-- オペレータ名 -->
              <v-col cols="6" class="font-weight-black">
                {{ wordList.lbl_operator_regist_name }} :
                {{ cognitUserCreateInput.name }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              variant="flat"
              class="px-16"
              @click="onClickCompletedGoStart"
            >
              {{ wordList.btn_operator_regist_return }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-card>
      <!-- } オペレータ登録完了ダイアログ -->
      <!-- { エラーダイアログ -->
      <AlertDialog
        v-model="errdialog"
        :title="wordList.lbl_err_dialog_title"
        :message="errMessage"
        type="error"
      />
      <!-- } エラーダイアログ -->
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import {
  required,
  max,
  min,
  alpha_dash,
  numeric,
  email as emailRule,
  confirmed,
  regex,
} from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";

import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import type { ChainItem, ShopItem } from "./types";

import { useOperatorRegisterUiState } from "./composables/useOperatorRegisterUiState";
import { useOperatorRegisterApi } from "./composables/useOperatorRegisterApi";
import { useOperatorRegisterForm } from "./composables/useOperatorRegisterForm";
import { useOperatorRegisterInit } from "./composables/useOperatorRegisterInit";
import { useOperatorRegisterActions } from "./composables/useOperatorRegisterActions";

// ルール定義
defineRule("required", required);
defineRule("max", max);
defineRule("min", min);
defineRule("alpha_dash", alpha_dash);
defineRule("numeric", numeric);
defineRule("email", emailRule);
defineRule("confirmed", confirmed);
defineRule("regex", regex);
configure({
  generateMessage: localize({ ja }),
});
setLocale('ja');

////////////////////////////////////////////////////////////////////////////////
// 共有リアクティブ状態（Form・Init 両方から参照されるため、コンポーネントレベルで生成）
////////////////////////////////////////////////////////////////////////////////
const wordList = ref<Record<string, string>>({});
const chainListItems = ref<ChainItem[]>([]);
const shopListItems = ref<ShopItem[]>([]);

////////////////////////////////////////////////////////////////////////////////
// Composables
////////////////////////////////////////////////////////////////////////////////

const {
  errdialog,
  errMessage,
  updateMode,
  overlay,
  displayConfirmDialog,
  displayCompletedDialog,
  createCognitoUserMutation,
  updateCognitoUserMutation,
  updateCognitoUserPasswordMutation,
} = useOperatorRegisterUiState();

const {
  getWordListData,
  getChainListData,
  getShopListData,
  getChainInfoData,
  getCognitoUserData,
  getCognitoUserCountData,
  getCognitoUserSameEmailCountData,
  createCognitoUserData,
  updateCognitoUserData,
  updateCognitoUserPasswordData,
} = useOperatorRegisterApi({ errdialog, errMessage });

const {
  personalRadioItems,
  cognitUserCreateInput,
  cognitoUserCountInput,
  cognitoUserSameEmailCountInput,
  shopListInput,
  chainSelectValues,
  shopSelectValues,
  groupSelectValues,
  personalSelectValues,
  personalDlSelectValues,
  authtypeSelectValues,
  operatorFormRef,
  groupRadioItems,
  authtypeRadioItems,
  chainViewFlag,
  shopViewFlag,
  personalDisabledFlag,
  isSelectOperatorGroupOther,
  isOperatorGroupOtherFlag,
  hasOperatorId,
  email_required,
  tel_required,
  isIpRestrictedChain,
  selectedOperatorGroupName,
  selectedOperatorChainName,
  comfirm_temporary_password,
  update_mode_operator_email,
  emailLabel,
  listEditFlag,
  checkIpRestricted,
  createGroupRadio,
  onClickGroup,
  onClickAuthType,
  onChangeChain,
  setChainCode,
  setShopCode,
  onBlurEmail,
  onBlurOperatorId,
  syncSelectionFields,
  allClear,
} = useOperatorRegisterForm({
  errdialog,
  errMessage,
  overlay,
  updateMode,
  wordList,
  chainListItems,
  shopListItems,
  getChainInfoData,
  getShopListData,
  getCognitoUserCountData,
  getCognitoUserSameEmailCountData,
});

const {
  isWordListReady,
  initialize,
  runInitialLoad,
} = useOperatorRegisterInit({
  errdialog,
  errMessage,
  overlay,
  updateMode,
  wordList,
  chainListItems,
  shopListItems,
  cognitUserCreateInput,
  cognitoUserCountInput,
  shopListInput,
  chainSelectValues,
  shopSelectValues,
  groupSelectValues,
  authtypeSelectValues,
  personalSelectValues,
  personalDlSelectValues,
  selectedOperatorGroupName,
  selectedOperatorChainName,
  update_mode_operator_email,
  email_required,
  tel_required,
  isIpRestrictedChain,
  chainViewFlag,
  personalRadioItems,
  operatorFormRef,
  getWordListData,
  getChainListData,
  getShopListData,
  getChainInfoData,
  getCognitoUserData,
  createGroupRadio,
  onClickGroup,
  setChainCode,
  setShopCode,
  checkIpRestricted,
  syncSelectionFields,
});

const {
  onClickBack,
  onClickOpenConfirmDialog,
  onClickConfirmCancel,
  onClickConfirmEntry,
  onClickCompletedGoStart,
} = useOperatorRegisterActions({
  errdialog,
  errMessage,
  overlay,
  updateMode,
  displayConfirmDialog,
  displayCompletedDialog,
  createCognitoUserMutation,
  updateCognitoUserMutation,
  updateCognitoUserPasswordMutation,
  cognitUserCreateInput,
  shopListInput,
  chainSelectValues,
  shopSelectValues,
  groupSelectValues,
  personalSelectValues,
  personalDlSelectValues,
  authtypeSelectValues,
  comfirm_temporary_password,
  email_required,
  tel_required,
  isIpRestrictedChain,
  update_mode_operator_email,
  chainViewFlag,
  wordList,
  chainListItems,
  shopListItems,
  listEditFlag,
  createCognitoUserData,
  updateCognitoUserData,
  updateCognitoUserPasswordData,
  getChainListData,
  getShopListData,
  setChainCode,
  createGroupRadio,
  onClickGroup,
  allClear,
  initialize,
});

////////////////////////////////////////////////////////////////////////////////
// 初期画面
////////////////////////////////////////////////////////////////////////////////
onMounted(async (): Promise<void> => {
  await runInitialLoad();
});
</script>

<style scoped></style>
